export default __webpack_public_path__ + "static/media/nav-bar-banner.25c85d89.png";